<template>
  <div class="base-header">
    <van-popover
      v-model="showPopover"
      trigger="click"
      :actions="actions"
      @select="onSelect"
      placement="bottom-end"
    >
      <template #reference>
        <div class="btn-bag">
          <van-icon name="wap-nav" size="22" style="font-weight: 600" />
        </div>
      </template>
    </van-popover>
  </div>
</template>

<script>
import { getToken } from '@/utils/cookies'
export default {
  name: 'WebHeaderView',
  data () {
    return {
      showPopover: false,
      actions:[],
      actions_tmp: [
        { text: '首页', key: 'home', show: true },
        { text: '登录账号', key: 'login', show: !getToken() },
        { text: '成为商家', key: 'register', show: !getToken() },
        { text: '我的商铺', key: 'mine', show: getToken() },
        { text: '关于我们', key: 'aboutus', show: true }
      ]
    }
  },
  watch:{
    showPopover(val){
      if(val){
        this.actions = []
        this.actions_tmp.forEach(element => {
          if(element.show){
            this.actions.push(element)
          }
        });
      }
    }
  },
  methods: {
    onSelect (val) {
       this.$router.push({ name: val.key }, () => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-bag {
  background: #fff;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  padding: 8px;
}
</style>
